//this will be moved once we have actual data
export const CHAR_LENGTH = 98

export const demographicList = ['age', 'ethnicity', 'gender']
